import {useLoad} from 'components/hooks';
import useLoadCustom from 'components/hooks/useLoadCustom';
import {pendingCourse} from 'constants/url';

export function useLoadPendingCourseCustom(
  cwid: string,
  status: number,
  customProps: any = null,
) {
  return useLoadCustom(
    `${pendingCourse}`,
    ['iD_Course', 'iD_Instance', 'employee_Nr'],
    {
      cwid: cwid,
      status: status,
    },
    true,
    true,
    true,
    customProps,
  );
}

export default function useLoadPendingCourse(cwid: string, status: number) {
  return useLoad(
    `${pendingCourse}`,
    ['iD_Course', 'iD_Instance', 'employee_Nr'],
    {
      cwid: cwid,
      status: status,
    },
  );
}
